export default "__VITE_ASSET__DwIDt8MR__"